import { useLayoutEffect, useState } from 'react';

import { Box } from '@gympass/yoga';
import { useIntl } from 'react-intl';

import { Checkbox } from 'components';

export const CHECKBOXES = ['UNDERSTANDING', 'COMPROMISE'];
const DocDownloadAgreement = ({
  onAgreement,
  disabled,
}: {
  disabled: boolean;
  onAgreement(agreed: boolean): void;
}) => {
  const intl = useIntl();
  const [state, setState] = useState({
    [CHECKBOXES[0]]: false,
    [CHECKBOXES[1]]: false,
  });

  useLayoutEffect(() => {
    onAgreement(Object.values(state).every(Boolean));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <>
      {CHECKBOXES.map(checkbox => (
        <Box key={checkbox} mt="4">
          <Checkbox
            disabled={disabled}
            checked={state[checkbox]}
            onChange={event => {
              setState(prevState => ({
                ...prevState,
                [checkbox]: event.target.checked,
              }));
            }}
            label={intl.formatMessage({
              id: `DOC_DOWNLOAD.FORM.CHECKBOX.${checkbox}`,
            })}
          />
        </Box>
      ))}
    </>
  );
};

export default DocDownloadAgreement;
